"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0149 6.0325c.0249-.5712.0897-1.0058.2544-1.3353C13.582 4.072 14.3794 4 14.9999 4V2c-1.4129 0-2.8497.4633-3.5194 1.8028-.3445.689-.4425 1.5017-.4701 2.2424C10.3046 5.69 9.5611 5.5 8.8124 5.5c-1.8806 0-3.0871 1.1995-4.1327 2.5936 1.2092 1.21 2.5693 2.5694 2.5696 4.4008.0002 1.7705-1.2888 3.0953-2.4694 4.2579.7234 1.4426 1.5213 2.9437 2.9718 3.7772 1.3817.794 2.9567.5659 4.2487-.2843 1.2996.8531 2.8916 1.0887 4.2913.3154 1.4753-.8152 2.2604-2.3006 2.8919-3.7911-1.1688-1.1689-2.4333-2.5076-2.433-4.2694.0002-1.8344 1.3582-3.1944 2.5695-4.4065C18.2746 6.6996 17.068 5.5 15.1874 5.5c-.7397 0-1.4744.1855-2.1725.5325zm-3.7656 6.4617c-.0002-1.5816-.6806-3.08-1.879-4.485.4495-.3522.9446-.5092 1.4421-.5092 1.356 0 2.3005 1.0272 3.1875 1.9142.887-.887 1.8316-1.9142 3.1875-1.9142.4975 0 .9926.157 1.4422.5092-1.1988 1.4054-1.8788 2.9046-1.879 4.4907-.0003 1.6595.7438 3.224 2.0486 4.6855-.3791.6861-.894 1.3037-1.4747 1.6246-1.258.6951-2.3974-.3391-3.3246-1.1117-.9036.753-2.0271 1.8009-3.2517 1.0971-.575-.3304-1.0926-.9606-1.5207-1.6785 1.288-1.4348 2.022-2.9794 2.0218-4.6227z"
  })];
};

exports.default = _default;